module.exports = __webpack_public_path__ + "img/options-pro410.1c335a61.svg";